
import { Component, ElementRef, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { SESSION_STORAGE, WebStorageService } from 'ngx-webstorage-service';
import { CatalogDetFacade } from '../../common/facade/CatalogDetFacade';
import { ImageCollectorFacade } from '../../common/facade/ImageCollectorFacade';
import { OrganizationFacade } from '../../common/facade/OrganizationFacade';
import { Strings } from '../../common/language/strings';
import { CatalogDet } from '../../common/model/CatalogDet';
import { Permissions } from '../../common/model/dictionary/Permissions';
import { CatalogDetInfo } from '../../common/model/dictionary/CatalogDetInfo';
import { Organization } from '../../common/model/Organization';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ImageViewerConfig } from 'ngx-image-viewer';
import { res } from '../../common/language/text/res';
import { ImageCollector } from '../../common/model/ImageCollector';
import { Photo } from '../../common/model/Photo';
import { Router } from '@angular/router';
import { CatalogInfo } from '../../common/model/dictionary/CatalogInfo';

@Component({
  selector: 'app-image-collector',
  templateUrl: './image-collector.component.html',
  styleUrls: ['./image-collector.component.scss']
})
export class ImageCollectorComponent implements OnInit {
  @ViewChild('fileDropRef', { static: false }) fileDropEl: ElementRef;
  @ViewChild('modal') public modal: ModalDirective;
  files: any[] = [];
  imgDefaultCreate = 'assets/images/ic-upload-file.svg';
  selectedImage = {src: this.imgDefaultCreate};


  titleImageCollector = res.ImageCollector;
  lblAddImage = res.CreateImageCollector;
  lblOrganization = res.Organization;
  lblOrganizationAdd = res.OrganizationImgCollectorAdd;
  lblModule = res.Module;
  lblModuleAdd = res.ModuleImgCollectorAdd;
  lblCancel = res.Cancel;
  lblContinue = res.Continue;
  lblSave = res.Save;
  lblSelectAnOption = res.SelectAnOption;
  lblActive = res.Active;
  lblCreateImage = res.CreateImage;
  lblActivate = res.Activate;
  lblDragnDrop = res.DragnDrop;
  lblBrowseForFile = res.BrowseForFile;
  lblOr = res.Or;

  modalAddImage: BsModalRef;
  alertsAddImage: any[] = [];
  alertsEditImage: any[] = [];
  config = {
    ignoreBackdropClick: true
  };
  messageTitleActive = '';
  messageActive = '';

  lsOrganizations: Organization[] = [];
  cmb_organization = '-1';
  cmb_organization_visible = true;
  lsModules: CatalogDet[] = [];
  cmb_modules = -1;
  lsOrganizationsAdd: Organization[] = [];
  cmb_organization_imageAdd = '-1';
  lsModulesAdd: CatalogDet[] = [];
  cmb_module_imageAdd = -1;
  flagOrganizationAdd = true;
  moduleLogIn = CatalogDetInfo.CatDetMobileModuleLogInId
  tenantId = -1;
  blobId = -1;
  active = false;
  imgCollector: ImageCollector;
  photos_gallery: any = [];
  configImageViewer: ImageViewerConfig = { customBtns: [] };
  imageIndexOne = 0;
  myFile: any = null;


  isSpanish = true;

  dateFileToUpload: any = null;
  fileToUpload: any = null;

  loading = false;
  messageLoader = '';

  generalAlerts = [];

  // permissions
  permissionsList: any[] = [];
  visibleAdd = false;
  visibleEdit = false;
  visibleDelete = false;
  fileName: any;
  photo: Photo;
  alertsModal: any[];
  imgToActivate = 0;
  modalConfirmation: BsModalRef;
  srcToEdit: any;
  loadImgEnable: boolean = true;

  constructor(
  @Inject(SESSION_STORAGE) private _storage: WebStorageService,
    private _imageCollectorFacade: ImageCollectorFacade,
    private _catalogFacade: CatalogDetFacade,
    private _organizationFacade: OrganizationFacade,
    public strings: Strings,
    private modalService: BsModalService,
    private _router: Router
  ) {
    this._storage.set('moduleUrl', this._router.url);
   }

  ngOnInit(): void {
    this.tenantId = this._storage.get('tenantId');
    this.getModules();
  }

  openModal() {
    this.initNewImage();
    this.getModules(true);

    this.modal.config.backdrop = 'static';
    this.modal.config.ignoreBackdropClick = true;
    this.modal.show();
  }

  initNewImage() {
    this.myFile = null;
    this.fileToUpload = null;
    this.alertsModal = [];
    this.alertsAddImage = [];
    this.alertsEditImage = [];
    this.selectedImage = { src: this.imgDefaultCreate};
    this.cmb_module_imageAdd = -1;
    this.cmb_organization_imageAdd = '-1';
    this.flagOrganizationAdd = true;
    this.loadImgEnable = false;
  }

  /**
   * on file drop handler
   */
  onFileDropped($event) {
    this.uploadImage($event, true);     
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler($event) {
    this.uploadImage($event);
  }

  grantedToCreated(): boolean {
    const permissionsList = this._storage.get('permissions');
    let granted = false;
    permissionsList.forEach(element => {
      if (element.name === Permissions.GeneralAccess
        || element.name === Permissions.ImageCollectorCreate
        ) {
        granted = true;
      }
    });
    return granted;
  }

  getOrganizations(addModal: boolean = false) {
    this.loading = true;
    // get Organizations
    if (addModal) {
      this.lsOrganizationsAdd = [];
      this.cmb_organization_imageAdd = '-1';
      this.files = [];
    } else {
      this.lsOrganizations = [];
      this.cmb_organization = '-1';
    }

    this._organizationFacade.GetCollectionByTenant(this.tenantId).subscribe(result => {
      this.loading = false;
      if (result.completed) {
        if (result.data != null) {
          if (addModal) {
            this.lsOrganizationsAdd = result.data;
          } else {
            this.lsOrganizations = result.data;
          }
        }
      }
    }, error => {
      this.loading = false;
      this.addAlert('<strong>' + error + '</strong>', 'danger', 'general');
      return;
    });
  }

  getModules(addModal: boolean = false) {
    this.loading = true;
    // get Catalog detail of Modules
    if (addModal) {
      this.lsModulesAdd = [];
      this.cmb_module_imageAdd = -1;
    } else {
      this.lsModules = [];
      this.cmb_modules = -1;
    }
    this._catalogFacade.Get(CatalogInfo.CatDetModules).subscribe(result => {
      this.loading = false;
      if (result.completed) {
        if (result.data != null) {
          if (addModal) {
            this.lsModulesAdd = result.data;
          } else {
            this.lsModules = result.data;
          }
        }
      }
      this.getOrganizations(addModal);
    }, error => {
      this.loading = false;
      this.addAlert('<strong>' + error + '</strong>', 'danger', 'general');
      return;
    });
  }

  // añadir alert
  addAlert(message: String, type: String, alertType: String): void {
    if (alertType == 'addImage') {
      this.alertsAddImage = [];
      this.alertsAddImage.push({
        type: type,
        msg: message      });
    } else if (alertType == 'editImage') {
      this.alertsEditImage = [];
      this.alertsEditImage.push({
        type: type,
        msg: message      });
    } else {
      this.generalAlerts = [];
      this.generalAlerts.push({
        type: type,
        msg: message
      });
    }

  }

  saveImage() {
    try {
      this.loading = true;
      if (! this.validateInfo()) {
        this.loading = false;
        return;
      }

      this.imgCollector = new ImageCollector();
      this.photo = new Photo();

      if (this.dateFileToUpload == null || this.dateFileToUpload == undefined) {
        this.loading = false;
        this.addAlert('<strong>' + this.strings.GetText(res.AlertCouldNotLoadImage) + '</strong>', 'danger', 'addImage');
        return;
      } 

      this.photo = {
        blobName: this.dateFileToUpload.name,
        blobStorId: 0,
        fileBase64 : this.fileToUpload,
        takenDate: new Date(),
        referenceKey: 0
      };

      this.imgCollector = {
        organizationId: this.cmb_organization_imageAdd
        , catDetMobileModuleId: this.cmb_module_imageAdd
        , active: true
        , blobStorId: 0
        , createdDate: new Date()
        , imageCollectorId: 0
        , lastDateUpdate: new Date()
        , MobileModuleName: ''
        , OrganizationName: ''
        , photo: this.photo};
      
      
      this._imageCollectorFacade.SaveImage(this.imgCollector).subscribe(result => {
          if (result.completed) {
            this.addAlert('<strong>' + this.strings.GetText(res.ImageCollectorSaveSuccessfully) + '</strong>', 'success', 'general');
            this.initNewImage();
            this.modal.hide();
          } else {
            this.addAlert('<strong>' + this.strings.GetText(res.AlertCouldNotSaveImageCollector) + ', ' + result.message + '</strong>', 'danger', 'general');
          }
          this.loading = false;
      }, error => {
        this.loading = false;
        this.addAlert('<strong>' + error + '</strong>', 'danger', 'general');
        return;
      });
    } catch (error) {
      this.addAlert('<strong>' + error + '</strong>', 'danger', 'general');
      this.loading = false;
    }   
  }

  validateInfo(): boolean {
    if (this.cmb_module_imageAdd == CatalogDetInfo.CatDetMobileModuleLogInId) {
      if (this.fileToUpload == null || this.fileToUpload.length == 0) {
        this.addAlert('<strong>' + this.strings.GetText(res.AlertCouldNotSaveImageCollectorImgNotLoaded) + '</strong>', 'danger', 'addImage');
        return false;
      } else {
        this.cmb_organization_imageAdd = '-1';
        return true;
      }
    }
    if ( this.cmb_module_imageAdd == -1 ) {
      this.addAlert('<strong>' + this.strings.GetText(res.AlertCouldNotSaveImageCollectorCmbModuleNotSelected)
       + '</strong>', 'danger', 'addImage');
      return false;
    }
    if ( this.cmb_organization_imageAdd == '-1') {
      this.addAlert('<strong>' + this.strings.GetText(res.AlertCouldNotSaveImageCollectorCmbOrganizationNotSelected)
       + '</strong>', 'danger', 'addImage');
      return false;
    }

    if ( this.fileToUpload == null || this.fileToUpload.length == 0) {
      this.addAlert('<strong>' + this.strings.GetText(res.AlertCouldNotSaveImageCollectorImgNotLoaded) + '</strong>', 'danger', 'addImage');
      return false;
    }
    
    return true;
  }

  validateInfoToEdit(): boolean {
    if (this.cmb_modules == CatalogDetInfo.CatDetMobileModuleLogInId) {
      this.cmb_organization = '-1';
      return true;
    }
    if ( this.cmb_modules == -1) {
      this.addAlert('<strong>' + this.strings.GetText(res.AlertCouldNotSaveImageCollectorCmbModuleNotSelected)
       + '</strong>', 'danger', 'addImage');
      return false;
    }
    if ( this.cmb_organization == '-1') {
      this.addAlert('<strong>' + this.strings.GetText(res.AlertCouldNotSaveImageCollectorCmbOrganizationNotSelected)
       + '</strong>', 'danger', 'addImage');
      return false;
    }
    if ( this.imgToActivate > 0) {
      this.addAlert('<strong>' + this.strings.GetText(res.AlertCouldNotSaveImageCollectorImgNotLoaded) + '</strong>', 'danger', 'addImage');
      return false;
    }
    return true;
  }

  validateFile(type: string): boolean {
    let flag = false;
    switch (type) {
      case 'image/jpeg' :
        flag = true;
        break;
      case 'image/jpg' :
        flag = true;
        break;
      case 'image/png' :
        flag = true;
        break;
      default:
        flag = false;
    }
      return flag;
  }

  // Método que se ejecuta al seleccionar un archivo para aviso
  uploadImage(event, dnd: boolean = false) {
    /* wire up file reader */
    
    let file: any;
    if (dnd) {
      file = event[0];
    } else {
      file = event.target.files[0];
    }
    
    if (this.selectedImage == file) {
      console.log("same")
      return;
    }

    // check file is valid
    if (!this.validateFile(file.type)) {
      this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertOnlyImgfilesAreAccepted), 'danger', 'addImage');
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = (e: any) => {
      this.fileToUpload = reader.result;
      this.dateFileToUpload = file;
      this.fileName = file.name;
      this.selectedImage = { src: this.fileToUpload};
    };
  }
  
  cleaImageLoaded() {
    this.myFile = null;
    this.fileToUpload = null;
    this.selectedImage = { src: this.imgDefaultCreate};
    this.loading = true;
    setTimeout(() => {
      // Continua con el proceso
      this.loading = false;
    }, 2000);
    
    
  }

  getBlobPhotos() {
    this.loading = true;
    this.photos_gallery = [];
    this.imageIndexOne = 0;
    if (this.cmb_modules == CatalogDetInfo.CatDetMobileModuleLogInId) {
      this.cmb_organization = this.lsOrganizations[1].organizationId;
      this.cmb_organization_visible = false;
    } else {
      this.cmb_organization_visible = true;
      if (this.cmb_modules == -1 || this.cmb_organization == '-1') {
        this.loading = false;
        return;
      }
    }

    this._imageCollectorFacade.GetImageCollectorByOrganizationModule(this.cmb_organization, this.cmb_modules).subscribe(result => {
      if (result.completed) {
        this.loading = false;
        if (result.data != null) {
          result.data.forEach(imgCollector => {
            const photo = {
              url: 'data:image/jpeg;base64,' + imgCollector.photo.fileBase64,
              active: imgCollector.active,
              imgCollectorId: imgCollector.imageCollectorId,
              organizationId: imgCollector.organizationId,
              catDetMobileModuleId: imgCollector.catDetMobileModuleId
            };
            this.photos_gallery.push(photo);
          });
        }
      } else {
        this.loading = false;
        this.addAlert('<strong>' + this.strings.GetText(res.FailedToGetImages) + '</strong>', 'danger', 'general');
      }
    }, error => {
      this.loading = false;
      this.addAlert('<strong>' + this.strings.GetText(res.FailedToGetImages) + '</strong>', 'danger', 'general');
    });
  }

  activateImage(imgCollectorId: number = 0, src: any,  template: TemplateRef<any>, action: number) {
    const classModal = 'gray modal-lg modal-primary';
    
    switch (action) {
      case 1:
          this.messageTitleActive = this.strings.GetText(res.ActivateImage);
          this.messageActive = this.strings.GetText(res.ImageWillBeActivated);
        break;

      case 2:
        if (this.validateInfoToEdit()) {
          this.imgToActivate = imgCollectorId;
          this.srcToEdit = '';
          this.srcToEdit = src;
          const moduleName = this.lsModules.find(x => x.catDetId == this.cmb_modules).name;
          let organizationName = '';
          if (this.cmb_modules != CatalogDetInfo.CatDetMobileModuleLogInId) {
            organizationName = this.lsOrganizations.find(x => x.organizationId == this.cmb_organization).name;
          }

          this.messageTitleActive = this.strings.GetText(res.ActivateImage);
          if (this.cmb_modules == CatalogDetInfo.CatDetMobileModuleLogInId) {
            this.messageActive = this.strings.GetText(res.SaveImageConfirmationAllOrganizations).replace('{0}', moduleName);
          } else {
            this.messageActive =
             this.strings.GetText(res.SaveImageConfirmation).replace('{0}', moduleName).replace('{1}', organizationName);
          }
        }
        break;
    }
    
    this.modalConfirmation = this.modalService.show(
      template,
      Object.assign({}, { class: classModal }, this.config)
    );
  }

  editImage() {
    if (this.photos_gallery.length > 0) {
      const img = this.photos_gallery.find(x => x.imgCollectorId ==  this.imgToActivate);
      if (img != null) {
        this.imgCollector = new ImageCollector();
        this.photo = new Photo();
        this.photo = {
          blobName: '',
          blobStorId: 0,
          fileBase64 : null,
          takenDate: new Date(),
          referenceKey: 0
        };
        this.imgCollector = {
          organizationId: img.organizationId
          , catDetMobileModuleId: img.catDetMobileModuleId
          , active: true
          , blobStorId: 0
          , createdDate: new Date()
          , imageCollectorId: img.imgCollectorId
          , lastDateUpdate: new Date()
          , MobileModuleName: ''
          , OrganizationName: ''
          , photo: this.photo
        };

        this.loading = true;
          this._imageCollectorFacade.ActivateImage(this.imgCollector).subscribe(result => {
            if (result.completed) {
              this.addAlert('<strong>' + this.strings.GetText(res.ImageCollectorUpdateSuccessfully) + '</strong>', 'success', 'general');
              this.onCloseModal();
              this.getBlobPhotos();
            } else {
              this.addAlert('<strong>' + this.strings.GetText(res.AlertCouldNotSaveImageCollector) + ', ' + result.message + '</strong>', 'danger', 'general');
            }
            this.loading = false;
        }, error => {
          this.loading = false;
          this.addAlert('<strong>' + error + '</strong>', 'danger', 'general');
          return;
        });
      }
    }
  }

  validateOrganizationOption(addModal: boolean = false) {
    this.cleaImageLoaded();
    this.cmb_organization_imageAdd = '-1';
    if (addModal && this.cmb_module_imageAdd == CatalogDetInfo.CatDetMobileModuleLogInId) {
      this.flagOrganizationAdd = false;
    } else {
      this.flagOrganizationAdd = true;
    }
  }

  onCloseModal() {
    this.srcToEdit = '';
    this.imgToActivate = 0;
    this.modalConfirmation.hide();
  }
}
